/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css } from 'aphrodite';
import { Modal } from '@blend/shared-react';
import { colors } from '@blend/consumer-components';
import { styles, getStyleConfig } from '../../components/common/Modals/styles';
import { useRootSelector } from '../../hooks/useRootSelector';

const overlayStyleConfig = {
  backgroundColor: colors.catalyst,
};

export namespace RoomExitPage {
  export interface Props {}
}

export const RoomExitPage: React.FC<RoomExitPage.Props> = ({}) => {
  const isMobileView = useRootSelector(state => state.layout.isMobileView);
  return (
    <Modal
      overlayStyleConfig={overlayStyleConfig}
      styleConfig={{ ...getStyleConfig(isMobileView), backgroundColor: colors.white, boxShadow: 'none' }}
      data-it="RoomExitPage"
      isOpen
      contentLabel="You’ve left the video call"
      handleClose={() => {}}
    >
      <div className={css(styles.content)}>
        <h1 className={css(styles.heading)}>You’ve left the video call</h1>
        <p className={css(styles.description)}>You can now close this window.</p>
      </div>
    </Modal>
  );
};
